import { useEffect } from 'react';

export const useActiveCallsData = getActiveCallsRequest => {
    useEffect(() => {
        const timer = setInterval(() => getActiveCallsRequest(), 3e4);

        return () => clearInterval(timer);
    }, []);
};
